/**
 * Middle-truncation: potong di tengah supaya bagian awal DAN bagian akhir
 * (yang paling unik pada ID/kode) tetap terlihat, dipisah elipsis "...".
 * Default: 26 karakter awal + "..." + 6 karakter akhir = 35 karakter total.
 *
 * Contoh:
 * middleEllipsisString("PLW-C15-1/TO20261002OBOY7/LT0QANVQ4J1")
 * → "PLW-C15-1/TO20261002OBOY7/...NVQ4J1"
 */
const middleEllipsisString = (text: string, head = 26, tail = 6) => {
  if (!text) {
    return "";
  }
  return text.length > head + 3 + tail
    ? `${text.substring(0, head)}...${text.substring(text.length - tail)}`
    : text;
};
export default middleEllipsisString;
